import React from 'react';
import { flatten } from 'nav-utilities';
import DesktopFooterMenu from '../DesktopFooterMenu';
import MobileFooterMenu from '../MobileFooterMenu';
import useMenuData from '../../utils/hooks/cmsDataHook';
import { DATA_TYPES, MENU_TYPES, PULSE_INSIGHTS } from '../../constants';
import useFeatureFlags from '../../utils/hooks/featureFlagsHook';
import LanguageTunnel from '../LanguageTunnel';
import { FooterMenuDiv, StyledHorizontalBar } from './styles';

/**
 * Formats the column object into a new object, whose structure should be easily consumed by
 * the components displaying the footer menu.
 * @param column {Node}
 * @returns {{children: *, header: *}}
 */
export const getColumnStructure = column => {
  const isSiteFeedbackEnabled = useFeatureFlags(PULSE_INSIGHTS);

  const handleSiteFeedbackFilter = data => {
    if (isSiteFeedbackEnabled) return data;
    return data?.filter(child => !child.url?.includes('site-feedback'));
  };

  // Flattening the column protects us from having a colum with two+ headers that may have their own children
  // We use the first child of the column as the header
  const flattenedColumnChildren = handleSiteFeedbackFilter(flatten(column.children));

  const [header, ...children] = flattenedColumnChildren;

  return {
    header: header,
    children: children,
  };
};

/**
 * Formats the column object into a new object, whose structure should be easily consumed by
 * the components displaying the footer menu.
 * @param column {Node}
 * @returns {{children: *, header: *}}
 */

const FooterMenu = () => {
  const menu = useMenuData(DATA_TYPES.FOOTER, MENU_TYPES.MAIN_FOOTER);
  if (!menu) return null;
  const { children: columns } = menu;
  if (!Array.isArray(columns) || !columns.length) return null;

  const formattedColumns = columns.map(getColumnStructure);

  return (
    <FooterMenuDiv data-testid="footer-menu">
      <MobileFooterMenu columns={formattedColumns} />
      <DesktopFooterMenu columns={formattedColumns} />
      <LanguageTunnel />
      <StyledHorizontalBar />
    </FooterMenuDiv>
  );
};

export default FooterMenu;
